import React, { useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import Routes from './pages/Routes';
import { useVersionCheck } from './lib/hooks/useVersionCheck';
import LoadingSpin from './components/UI/Feedback/LoadingSpin';
import { ConfigProvider } from 'antd';
import locale from 'antd/es/locale/de_DE';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';

dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.locale('de');

const App: React.FC = () => {
  const location = useLocation();
  const [isReloading, setIsReloading] = useState(false);

  const { checkAndReload } = useVersionCheck({
    currentVersion: import.meta.env.VITE_APP_VERSION,
    onNewVersionDetected: useCallback(() => setIsReloading(true), []),
    enabled: import.meta.env.PROD,
  });

  useEffect(() => {
    checkAndReload();
  }, [location, checkAndReload]);

  useEffect(() => {
    if (isReloading) {
      requestAnimationFrame(() => {
        window.location.href = location.pathname + location.search + location.hash;
      });
    }
  }, [isReloading, location]);

  if (isReloading) {
    return <LoadingSpin />;
  }

  return (
    <ConfigProvider locale={locale}>
      <div className='App'>
        <Routes />
      </div>
    </ConfigProvider>
  );
};

export default App;
